"use strict";

module.exports = function getBase(groupId, twelveHourTime) {
  if (!groupId) return twelveHourTime ? 12 : 24;
  if (groupId < 3) return 60;
  return 1000;
};


//////////////////
// WEBPACK FOOTER
// ./~/time-input/dist/lib/get-base.js
// module id = 2028
// module chunks = 0